module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-3d-controls"
  }, [_c('a', {
    staticClass: "prev",
    class: {
      disabled: !_vm.parent.isPrevPossible
    },
    style: (("width: " + _vm.width + "px; height: " + _vm.height + "px; line-height: " + _vm.height + "px;")),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.parent.goPrev()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prevHtml)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "next",
    class: {
      disabled: !_vm.parent.isNextPossible
    },
    style: (("width: " + _vm.width + "px; height: " + _vm.height + "px; line-height: " + _vm.height + "px;")),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.parent.goNext()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextHtml)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2f75e16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Controls.vue
// module id = 1828
// module chunks = 180